import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { TableBaseStyle, StorageCapacitySettingStyle } from './StorageCapacitySettingStyle';
import { FILE_STORAGE_PERIOD } from './StorageCapacitySetting';
import NumericEntry_inputEx from './../../../atoms/Input/NumericEntry_inputEx';
import { useTranslation } from 'react-i18next';

type StorageCapacitySettingEditBodyProps = {
  storageSetting: FILE_STORAGE_PERIOD;
  onChangeData: (targetRow: FILE_STORAGE_PERIOD) => void;
};

const StorageCapacitySettingEditBody: React.FC<StorageCapacitySettingEditBodyProps> = (props) => {
  const tableStyle = TableBaseStyle();
  const pageStyle = StorageCapacitySettingStyle();

  const [storageSetting, setStorageSetting] = useState<FILE_STORAGE_PERIOD>(props.storageSetting); //データ初期値
  const { t, i18n } = useTranslation();

  /**
   * データ変更通知
   */
  useEffect(() => {
    //データ初期値にセットされている内容を再描画時に変えたい場合、useEffectが必要
    console.debug(['StorageCapacitySettingEditBody - useEffect props.storageSetting', props.storageSetting]);
    setStorageSetting({ ...props.storageSetting });
  }, [props.storageSetting]);
  /**
   * 上位にデータ変更通知
   * @param editRow　編集対象データ
   * @param isEdit 編集フラグ
   * @returns
   */
  const onChangeData = (editRow: FILE_STORAGE_PERIOD, editFlg: boolean) => {
    if (editFlg) {
      //console.debug(['onChangeData - editRow,baseData', editRow, props.storageSetting]);
      props.onChangeData(editRow);
    }
  };

  return (
    <Paper elevation={3} classes={{ root: pageStyle.paperRoot }}>
      <Table stickyHeader aria-label="a dense table">
        <TableBody>
          <TableRow>
            <TableCell className={tableStyle.headerCell}>
              {t('StorageCapacitySettingEditBody.ストレージ容量', 'ストレージ容量(GB)')}
            </TableCell>
            <TableCell className={tableStyle.bodyCell} width={150}>
              <NumericEntry_inputEx
                className={tableStyle.textField}
                value={storageSetting.FREE_SPACE}
                minValueLimit={1}
                maxValueLimit={12288}
                fixed={0}
                onChange={(val) => {
                  if (props.storageSetting.FREE_SPACE !== val) {
                    storageSetting.FREE_SPACE = val;
                    onChangeData(storageSetting, true);
                    console.debug(['NumericEntry_inputEx - onChange - FREE_SPACE', val, storageSetting]);
                  }
                }}
              />
            </TableCell>
            <TableCell className={tableStyle.headerCell}>
              {t('StorageCapacitySettingEditBody.ファイル保存期間', 'ファイル保存期間(日)')}
            </TableCell>
            <TableCell className={tableStyle.bodyCell} width={150}>
              <NumericEntry_inputEx
                className={tableStyle.textField}
                value={storageSetting.FILE_RET_PERIOD}
                minValueLimit={10}
                maxValueLimit={9999}
                fixed={0}
                onChange={(val) => {
                  if (props.storageSetting.FILE_RET_PERIOD !== val) {
                    storageSetting.FILE_RET_PERIOD = val;
                    onChangeData(storageSetting, true);
                    console.debug(['NumericEntry_inputEx - onChange - FILE_RET_PERIOD', val, storageSetting]);
                  }
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
};

export default StorageCapacitySettingEditBody;
